import query from './query';
import { keys } from './keys';
import Component from '../../components/Component';
import ListData from '../../components/ListData';

class Summary extends Component {
    constructor(props) {
        super();
        if (props.isShowAuthors)
            this.query = query({
                offset: 0,
                domain: props.domain,
                limit: 10,
            });

        this.offsetStep = 100;
    }

    render() {
        return (
            <ListData
                loading={this.state.loading}
                header={this.props.header ?? 'Top Authors'}
                subheader={this.props.subheader ?? '(by impression)'}
                forceRun={this.forceRun}
                link={this.props.link}
                keys={keys}
                uniqKey="author"
                data={this.state.data}
                cardClassName={'list-data-full'}
                showError={!this.props.isShowAuthors}
                customErrorMessage="Top Authors data is disabled by main user."
            />
        );
    }
}

export default Summary;
